<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :items="scripts" :headers="headers" style="cursor: pointer">
      <template v-slot:items="props">
        <td class="text-xs-center" @click="openItem(props.item)">
          {{ props.item.name }}
        </td>
        <td class="text-xs-center" @click="openItem(props.item)">
          {{ props.item.description }}
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="zhoneModal" width="1200px" persistent>
      <v-card flat color="white" v-if="item">
        <v-toolbar flat color="primary">
          <h3 class="white--text">{{ item.name }}</h3>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading"
            size="20"
            indeterminate
            color="white"
          ></v-progress-circular>
          <v-btn
            v-if="selectItemType == 'source'"
            flat
            color="white"
            :disabled="!sourceItem"
            @click="setSource()"
            >Next</v-btn
          >
          <v-btn
            v-if="selectItemType == 'destination'"
            flat
            color="white"
            :disabled="!destinationItem"
            @click="setDestination()"
          >
            Next
          </v-btn>
          <!-- <v-btn v-if="selectItemType == 'provisionSelection'" flat @click="settingsModal = true"><v-icon>Settings</v-icon></v-btn> -->
          <v-btn
            v-if="selectItemType == 'provisionSelection' && !loading"
            flat
            color="white"
            :disabled="!provisionTypes.filter((x) => x.value).length > 0"
            @click="collectProvisionData()"
            >Next
          </v-btn>
          <v-btn
            v-if="selectItemType == 'finalVerification' && !loading"
            flat
            color="white"
            @click="buildScript('zhone')"
            >Build Script</v-btn
          >
          <v-btn
            v-if="selectItemType == 'script' && !loading"
            flat
            color="white"
            @click="runScript()"
            >Run Script</v-btn
          >
          <v-btn
            color="white"
            flat
            @click="
              (zhoneModal = false),
                (item = {}),
                (itemTree = []),
                (selectItemType = 'source')
            "
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text v-if="selectItemType == 'source'">
          <v-layout justify-center align-center>
            <h3 class="grey--text">Select a source item:</h3>
          </v-layout>
          <v-treeview
            item-disabled="locked"
            open-on-click
            transition
            class="grey--text"
            :activatable="false"
            :items="itemTree"
            :key="treeUpdateKey"
            :load-children="fetchLinkedData"
            :active.sync="active"
            :open.sync="open"
            item-key="Handle_Id"
          >
            <template v-slot:label="{ item }">
              <div v-if="item.type == 'MXK'">
                <h4 class="text-xs-left">
                  {{ item.Handle_Type }} <i>({{ item.Device_Id }})</i>
                </h4>
                <i
                  ><h5 class="text-xs-left font-weight-light">
                    {{ item.type }}
                  </h5></i
                >
              </div>
              <div v-else-if="item.type == 'Card' || item.type == 'Port'">
                <v-layout justify-left align-center wrap>
                  <v-flex xs1
                    ><v-checkbox
                      v-model="item.selected"
                      @change="setItem(selectItemType, item.type, item)"
                    ></v-checkbox
                  ></v-flex>
                  <v-flex xs10>
                    <h4 class="text-xs-left">
                      {{ item.Handle_Type }}
                    </h4>
                    <i
                      ><h5 class="text-xs-left font-weight-light">
                        {{ item.name }}
                      </h5></i
                    >
                  </v-flex>
                </v-layout>
              </div>
            </template>
          </v-treeview>
        </v-card-text>
        <v-card-text v-else-if="selectItemType == 'destination'">
          <v-layout justify-center align-center>
            <h3 class="grey--text">Select a destination item:</h3>
          </v-layout>
          <v-treeview
            item-disabled="locked"
            open-on-click
            transition
            class="grey--text"
            item-key="Handle_Id"
            :activatable="false"
            :items="itemTree"
            :key="treeUpdateKey"
            :load-children="fetchLinkedData"
            :active.sync="active"
            :open.sync="open"
          >
            <!-- <template v-slot:prepend="{ item }" >
                            <v-checkbox v-if="item.type == 'Card' || item.type == 'Port'" v-model="item.selected" @change="setItem('source', item.type, item)"></v-checkbox>
                          </template> -->
            <template v-slot:label="{ item }">
              <div v-if="item.type == 'MXK'">
                <h4 class="text-xs-left">
                  {{ item.Handle_Type }}<i>({{ item.Device_Id }})</i>
                </h4>
                <i
                  ><h5 class="text-xs-left font-weight-light">
                    {{ item.type }}
                  </h5></i
                >
              </div>
              <div v-else-if="item.type == 'Card' || item.type == 'Port'">
                <v-layout justify-left align-center wrap>
                  <v-flex xs1
                    ><v-checkbox
                      :disabled="sourceItem && item.type != sourceItem.type || sourceItem.Handle_Id == item.Handle_Id"
                      v-model="item.selected"
                      @change="setItem(selectItemType, item.type, item)"
                    ></v-checkbox
                  ></v-flex>
                  <v-flex xs10>
                    <h4 class="text-xs-left">
                      {{ item.Handle_Type }}
                    </h4>
                    <i
                      ><h5 class="text-xs-left font-weight-light">
                        {{ item.name }}
                      </h5></i
                    >
                  </v-flex>
                </v-layout>
              </div>
            </template>
          </v-treeview>
        </v-card-text>
        <v-card-text v-if="selectItemType == 'provisionSelection'">
          <v-layout justify-center align-center>
            <h3 class="grey--text">
              Select the configurations to be transferred:
            </h3>
          </v-layout>
          <v-layout justify-center align-center wrap>
            <v-flex xs12
              ><h3 class="grey--text font-weight-light">
                From: {{ sourceItem.Device_Id }} {{ sourceItem.type }}
                {{ sourceItem.name }}
              </h3></v-flex
            >
            <v-flex xs12
              ><h3 class="grey--text font-weight-light">
                To: {{ destinationItem.Device_Id }} {{ destinationItem.type }}
                {{ destinationItem.name }}
              </h3></v-flex
            >
            <v-flex xs3 v-for="item in provisionTypes" :key="item.label">
              <v-checkbox
            :label="item.label"
            v-model="item.value"
          ></v-checkbox>
            </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-text v-if="selectItemType == 'finalVerification'">
          <v-layout justify-center align-center>
            <v-flex xs3>
              <h3>Devices <v-chip>{{devices.length}}</v-chip></h3>
            </v-flex>
          </v-layout>
          
          <v-tabs>
            <v-tab
              v-for="tab in provisionTypes.filter((x) => x.value)"
              :key="tab.type"
              @click="selectedTab = tab.type"
              >{{ tab.label }}</v-tab
            >
          </v-tabs>
          <v-data-table
            v-if="selectedTab == 'dynamicOmci'"
            :items="dynamicOmci"
            :headers="dynamicOmciHeaders"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                {{ props.item.name }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection ? props.item.connection.vlanId : null
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection
                    ? props.item.connection.vlanXlateId
                    : null
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection ? props.item.connection.slanId : null
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection
                    ? props.item.connection.slanXlateId
                    : null
                }}
              </td>
              <td class="text-xs-center">
                {{ props.item.egressGroupIndex }}
              </td>
              <td class="text-xs-center">
                {{ props.item.groupIndex }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection ? props.item.connection.tpType : null
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection ? props.item.connection.tpIndex : null
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.connection ? props.item.connection.rgMode : null
                }}
              </td>
            </template>
          </v-data-table>
          <v-data-table
            v-if="selectedTab == 'pppoe'"
            :items="pppoe"
            :headers="pppoeHeaders"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                {{ props.item.userName }}
              </td>
              <td class="text-xs-center">
                {{ props.item.password }}
              </td>
              <td class="text-xs-center">
                {{ props.item.vlanId }}
              </td>
              <td class="text-xs-center">
                {{ props.item.slanId }}
              </td>
              <td class="text-xs-center">
                {{
                  [
                    props.item.Shelf_Id,
                    props.item.Card_Id_1,
                    props.item.Physical_Id_1,
                    props.item.Physical_Id_2,
                  ].join("-")
                }}
              </td>
            </template>
          </v-data-table>
          <v-data-table
            v-if="selectedTab == 'wifi'"
            :items="wifi"
            :headers="wifiHeaders"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                {{ props.item.ssid }}
              </td>
              <td class="text-xs-center">
                {{ props.item.encryptKey }}
              </td>
              <td class="text-xs-center">
                {{
                  [
                    props.item.Shelf_Id,
                    props.item.Card_Id_1,
                    props.item.Physical_Id_1,
                    props.item.Physical_Id_2,
                  ].join("-")
                }}
              </td>
            </template>
          </v-data-table>

          <!-- </div> -->
          <div v-if="selectedTab == 'pppoe'"></div>
          <div v-if="selectedTab == 'wifi'"></div>
        </v-card-text>

        <v-card-text v-else-if="selectItemType == 'script'">
          <v-layout justify-center align-center wrap>
            <v-flex xs3>
              <h3 class="grey--text">
                Devices <v-chip>{{ script.length }}</v-chip>
              </h3>
            </v-flex>
            <v-flex xs3>
              <!-- <v-btn flat>
                <v-icon>get_app</v-icon>
                <download-excel
                  :data="script"
                  :fields="exportFields"
                  worksheet="export"
                  :name="'script_' + new Date().getTime() + '.xls'"
                  >Export to Excel</download-excel
                >
              </v-btn> -->
              <v-btn flat>
                <vue-excel-xlsx
        :data="finalBridge"
        :columns="bridgeColumns"
        :file-name="'bridge'"
        :file-type="'xlsx'"
        :sheet-name="'export'"
        >
        Download
    </vue-excel-xlsx>
                <v-icon>get_app</v-icon>
                <!-- <download-excel
                  :data="finalBridge"
                  worksheet="export"
                  :name="'bridge_' + new Date().getTime() + '.xls'"
                  >Download Bridges</download-excel
                > -->
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
             
            </v-flex>
            <v-flex xs4>
              <!-- <v-btn flat>
                <v-icon>get_app</v-icon>
                <download-excel
                  :data="finalWAN"
                  worksheet="export"
                  :name="'wan_' + new Date().getTime() + '.xls'"
                  >Download WAN</download-excel
                >
              </v-btn> -->
            </v-flex>
            <v-flex xs4>
              <!-- <v-btn flat>
                <v-icon>get_app</v-icon>
                <download-excel
                  :data="finalWLAN"
                  worksheet="export"
                  :name="'wlan_' + new Date().getTime() + '.xls'"
                  >Download WLAN</download-excel
                >
              </v-btn> -->
            </v-flex>
          </v-layout>
          <v-toolbar flat color="white"
            ><v-spacer></v-spacer
            ><v-text-field label="Search" v-model="searchZms"></v-text-field
          ></v-toolbar>
          <v-data-table
            :search="searchZms"
            :items="script"
            :headers="scriptHeaders"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon v-if="props.item.started" color="blue"
                  >check_circle</v-icon
                >
                <v-icon v-else color="orange">warning</v-icon>
              </td>
              <td class="text-xs-center">
                <v-icon
                  v-if="props.item.started && props.item.success"
                  color="light-green"
                  >check_circle</v-icon
                >
                <v-icon
                  v-else-if="props.item.started && !props.item.success"
                  color="red"
                  >cancel</v-icon
                >
              </td>
              <td class="text-xs-center">
                {{ props.item.fsan }}
              </td>
              <td class="text-xs-center">
                {{ props.item.objects.length }}
              </td>
              <td class="text-xs-center">
                {{ JSON.stringify(props.item.objects) }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text v-else-if="selectItemType == 'runningScript'">
          <v-layout justify-center align-center wrap >
            <v-flex xs3>
              <h3 class="grey--text">
                Total <v-chip>{{total}}</v-chip>
              </h3>
            </v-flex>
            <v-flex xs3>
              <h3 class="grey--text">
                Successful <v-chip>{{success}}</v-chip>
              </h3>
            </v-flex>
            <v-flex xs3>
              <h3 class="grey--text">
                Failed <v-chip>{{failed}}</v-chip>
              </h3>
            </v-flex>
            <v-flex xs3 v-if="!runningScript">
              <h3 class="grey--text">
                Success Rate <v-chip>{{Math.round((success/total)*100)}} %</v-chip>
              </h3>
            </v-flex>
          </v-layout>
          
          <v-layout justify-center align-center wrap >
            <v-flex xs6>
              <h3 class="grey--text">Source: <i class="grey--text font-weight-light">{{ sourceItem.name }}</i></h3>
              <h3 class="grey--text">Destination: <i class="grey--text font-weight-light">{{ destinationItem.name }}</i></h3>

            </v-flex>
            <v-flex xs12 v-if="runningScript">
              <v-progress-circular
            v-if="runningScript"
            size="20"
            indeterminate
            color="grey"
          ></v-progress-circular>
            </v-flex>
            <v-flex xs12 :key="currentDevice">
              <h3 :key="currentDevice">Device: {{currentDevice}}/{{script.length}} <i>{{Math.round((currentDevice/script.length)*100)}}%</i></h3>
            </v-flex>
            <v-flex xs12>
              <h3  class="grey--text">Time Started: <span  class="grey--text font-weight-light">{{formatDateTime(timeStarted)}}</span></h3>
            </v-flex>
            <v-flex xs12 v-if="averageTime">
              <h3 class="grey--text">Average Time Per Device: <span  class="grey--text font-weight-light">{{millisToMinutesAndSeconds(averageTime)}}</span></h3>
            </v-flex>
             <v-flex xs12 v-if="averageTime">
              <h3  class="grey--text">ETA End: <span  class="grey--text font-weight-light">{{formatDateTime(new Date(timeStarted.getTime() + averageTime*script.length))}}</span></h3>
            </v-flex>
          </v-layout>
           <v-layout justify-center align-center wrap  v-if="!runningScript">
            <v-flex xs3>
              <v-btn flat>
                <v-icon>get_app</v-icon>
                <download-excel
                  :data="successfulArray"
                  :fields="exportSuccessFields"
                  worksheet="export"
                  :name="'success_' + new Date().getTime() + '.xls'"
                  >Export Successful</download-excel
                >
              </v-btn>
            </v-flex>
            <v-flex xs3>
              
              <v-btn flat>
                <v-icon>get_app</v-icon>
                <download-excel
                  :data="failedArray"
                  :fields="exportFailedFields"
                  worksheet="export"
                  :name="'failed_' + new Date().getTime() + '.xls'"
                  >Export Failed</download-excel
                >
              </v-btn>
            </v-flex>
          </v-layout>
           <v-data-table
           v-if="!runningScript"
            :search="searchZms"
            :items="script"
            :headers="scriptCompleteHeaders"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                {{ props.item.fsan }}
              </td>
              <td class="text-xs-center">
                {{ props.item.objects.length }}
              </td>
              <td class="text-xs-center">
                {{ (props.item.objects.filter(x=>x.success).length) }}
              </td>
              <td class="text-xs-center">
                {{ (props.item.objects.filter(x=>!x.success).length) }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- ZMS Sync -->
    <v-dialog v-model="syncModal" persistent width="400px">
      <v-card v-if="item" :key="item.key">
        <v-toolbar flat color="white">
          <v-toolbar-title>
            Sync ZMS
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="syncModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text :key="syncKey">
          <v-layout justify-center :key="syncKey">
            <v-flex xs10 class="text-xs-center" :key="syncKey" > <v-btn v-if="!syncStarted" flat @click="triggerZhoneSync()"><v-icon mr-1>play_arrow</v-icon> Start Sync</v-btn>
            <span v-else>Sync successfully triggered!</span>
            </v-flex>
             <!-- <v-flex xs10 class="text-xs-center" v-else>
              
            </v-flex> -->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ZMS Sync -->
    <v-dialog v-model="syncLocationModal" persistent width="400px">
      <v-card v-if="item" :key="item.key">
        <v-toolbar flat color="white">
          <v-toolbar-title>
            Sync ZMS Locations
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="syncLocationModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text :key="syncLocationKey">
          <v-layout justify-center :key="syncLocationKey">
            <v-flex xs10 class="text-xs-center" :key="syncLocationKey" > <v-btn v-if="!syncLocationStarted" flat @click="triggerLocationSync()"><v-icon mr-1>play_arrow</v-icon> Start Sync</v-btn>
            <span v-else>Sync successfully triggered!</span>
            </v-flex>
             <!-- <v-flex xs10 class="text-xs-center" v-else>
              
            </v-flex> -->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import axios from "axios";
import dateformat from "dateformat";
const CancelToken = axios.CancelToken;
let source = null;
export default {
  data() {
    return {
      active: [],
      currentDevice: 0,
      success: 0,
      failed: 0,
      bridgeColumns: [],
      finalBridge: [],
      finalWAN: [],
      finalWLAN: [],
      total: 0,
      devices: [],
      dynamicOmci: [],
      exportFields: {
        fsan: "fsan",
        numberOfObjects: {
          callback: (value) => {
            return value.objects.length;
          },
        },
        object: {
          callback: (value) => {
            return JSON.stringify(value);
          },
        },
      },
      exportSuccessFields: {
        type: "type",

        fsan: "fsan",
        object: {
          callback: (value) => {
            return JSON.stringify(value);
          },
        },
      },
      exportFailedFields: {
        type: "type",

        fsan: "fsan",
        error: "error",
        object: {
          callback: (value) => {
            return JSON.stringify(value);
          },
        },
      },
      pppoe: [],
      wifi: [],
      open: [],
      itemTree: [],
      item: {},
      loading: false,
      runningScript: false,
      destinationItem: null,
      timeStarted: null,
      averageTime: null,
      etaEnd: null,
      script: [],
      successfulArray: [],
      failedArray: [],
      scriptModal: false,
      searchZms: "",
      selectItemType: "source",
      selectedTab: "",
      sourceItem: null,
      treeUpdateKey: 0,
      zhoneModal: false,
      syncModal: false,
      syncLocationModal: false,
      syncStarted: false,
      syncLocationStarted: false,
      syncKey: 0,
      syncLocationKey: 0,
      provisionTypes: [
        { label: "Bridges", type: "dynamicOmci", value: false },
        { label: "PPPoE Profiles", type: "pppoe", value: false },
        { label: "WLAN Profiles", type: "wifi", value: false },
      ],
      scripts: [
        {
          name: "ZMS Card Swap",
          type: "zhoneCardSwap",
          description:
            "Ability to mass provision ONU's from one card to another.",
        },
         {
          name: "Sync ZMS",
          type: "zmsSync",
          description:
            "Manually triggers sync between ZMS & TelecoGlue.",
        },
        {
          name: "Sync ZMS Locations",
          type: "zmsLocationSync",
          description:
            "Manually triggers sync between ZMS & TelecoGlue locations.",
        },
      ],
      
      search: "",
      headers: [
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Description",
          align: "center",
          value: "description",
        },
      ],
      pppoeHeaders: [
        {
          text: "Username",
          align: "center",
          value: "userName",
        },
        {
          text: "Password",
          align: "center",
          value: "password",
        },
        {
          text: "Vlan ID",
          align: "center",
          value: "vlanId",
        },
        {
          text: "Slan ID",
          align: "center",
          value: "slanId",
        },
        {
          text: "System Location",
          align: "center",
          sortable: false,
        },
      ],
      wifiHeaders: [
        {
          text: "SSID",
          align: "center",
          value: "ssid",
        },
        {
          text: "Password",
          align: "center",
          value: "encryptKey",
        },
        {
          text: "System Location",
          align: "center",
          sortable: false,
        },
      ],
      scriptHeaders: [
        {
          text: "Started",
          align: "center",
          value: "started",
        },
        {
          text: "Complete",
          align: "center",
          value: "complete",
        },
        {
          text: "FSAN",
          align: "center",
          value: "fsan",
        },
        {
          text: "Objects",
          align: "center",
          value: "objects",
        },
        {
          text: "Object",
          align: "center",
          sortable: false,
        }
      ],
      scriptCompleteHeaders: [
        {
          text: "FSAN",
          align: "center",
          value: "fsan",
        },
        {
          text: "Objects",
          align: "center",
          value: "objects",
        },
        {
          text: "Success",
          align: "center",
          sortable: false,
        }
        ,
        {
          text: "Fail",
          align: "center",
          sortable: false,
        }
      ],
      dynamicOmciHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "VlanId",
          align: "center",
          value: "vlanId",
        },
        {
          text: "VlanXlateId",
          align: "center",
          value: "vlanXlateId",
        },
        {
          text: "SlanId",
          align: "center",
          value: "slanId",
        },
        {
          text: "SlanXlateId",
          align: "center",
          value: "slanXlateId",
        },
        {
          text: "Egress",
          align: "center",
          value: "egressGroupIndex",
        },
        {
          text: "Ingress",
          align: "center",
          value: "groupIndex",
        },

        {
          text: "TpType",
          align: "center",
          value: "tpType",
        },
        {
          text: "TpIndex",
          align: "center",
          value: "tpIndex",
        },
        {
          text: "RG Mode",
          align: "center",
          value: "rgMode",
        },
      ],
    };
  },
  async destroyed() {
    source.cancel("Operation canceled by the user.");
  },
  created() {
    source = CancelToken.source();
  },
  methods: {
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM:ss");
      } else {
        null;
      }},
    millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
},
    async openItem(item) {
      console.log(item);
      if (this.authAdmin(this.$store.state.currentRoute)) {
        this.item = item;
        if (this.item.type == "zhoneCardSwap") {
          this.buildTree("zhone");
          this.zhoneModal = true;
        } else if(this.item.type == "zmsSync"){
          this.item.key = 0
          this.item.sync = false
          
          this.syncModal = true
        } else if(this.item.type == "zmsLocationSync"){
          this.item.key = 0
          this.item.sync = false
          this.syncLocationStarted = false
          this.syncLocationModal = true
        }
      }
    },
    async setItem(type, level, item) {
      if (type == "source") {
        if (level == "Port") {
          this.sourceItem = item;
        } else if (level == "Card") {
          if (item.children.length == 0) {
            await this.fetchLinkedData(item);
            this.sourceItem = item;
          }
        }
        this.open=[]
        this.active=[]

        this.selectItemType = 'destination'
      } else if (type == "destination") {
        this.destinationItem = item;
      }
    },
    async setSource() {
      this.selectItemType = "destination";
      this.destinationItem = null;
      this.buildTree("zhone");
    },
    async setDestination() {
      console.log("source", this.sourceItem);
      console.log("destination", this.destinationItem);
      this.selectItemType = "provisionSelection";
    },
    async removeONU(handleId){
      let result = null
      await Api().post('/aps/zhone/removeOnu', {
        handleId: handleId
      }).then(res=>{
        result = res.data
      })
      return result
    },
    async fetchNextAvailableONU(deviceId, cardId, oltId) {
      let result = null;
      await Api()
        .get(`/zhone/nextFreeOnu/${deviceId}/${cardId}/${oltId}`,{
          cancelToken: source.token
        })
        .then((res) => {
          console.log(res.data);
          result = res.data;
        });
      return result;
    },
    delay(delayInms) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(2);
    }, delayInms);
  });
},
async createOnu(obj){
  let result = null
  await Api().post('/aps/zhone/modifyFsan', obj).then(res=>{
    result = res.data
  })
  return result
},
    async addONU(object) {
      let result = {
        code: 500,
        message: "error",
      };
      let newONU = await this.fetchNextAvailableONU(
        object.destinationMXK,
        object.destination.split("-")[1],
        object.destination.split("-")[2]
      );
      if (newONU && newONU.code == 200 && newONU.data) {
        let message = '(1/3) Next ONU Retrieved'
         let remove = await this.removeONU(object.handleId)
         console.log('Remove', remove)
        if(remove&&remove.code == 200){
          message = '(2/3) ONU Removed from old slot'
        }
        let addOnu = await this.createOnu({handleId: newONU.data.Handle_Id, fsan: object.fsan,  meProfile: object.meProfile, portDesc: object.portDesc})
        console.log("Add", addOnu)
        if(addOnu&&addOnu.code == 200){
          message = '(3/3) Onu added to new slot'
        }
        // Add code to update new fsan
        result = {
          code: addOnu?addOnu.code:200,
          message: message,
          onuId: newONU.data.Physical_Id_2,
          handleId: newONU.data.Handle_Id,
          ifIndex: newONU.data.ifIndex,
          newONU: newONU.data
        };
      } else {
        result = {
          code: 500,
          message: "No free ONU. ONU not added",
        };
      }
      // await this.delay(1000);
      return result;
    },
    setBridgeTemplateName(vlan){
      let bridge = null
      if([180, 4042, 4045, 44, 39, 60, 810].includes(parseInt(vlan))){
        bridge = 'DownlinkSingleTagged'
      } else if([205, 300, 800].includes(parseInt(vlan))){
        bridge = 'Transparent LANSingleTagged'
      } else if([1950, 1980, 2222].includes(parseInt(vlan))){
        bridge = 'Transparent LANDoubleTagged'
      } else {
        bridge =  'DownlinkSingleTagged'
      }
      return bridge
    },
    async createBridge(obj){
      let result = null
      await Api().post('/aps/zhone/configureOnuDirect', obj).then(res=>{
        result = res.data
      })
      return result
    },
    async createPPPOE(obj){
      let result = null
      await Api().post('/aps/zhone/configurePPPOE', obj).then(res=>{
        result = res.data
      })
      return result
    },
    async createWifi(obj){
      let result = null
      await Api().post('/aps/zhone/createWifi', obj).then(res=>{
        result = res.data
      })
      return result
    },
    async attachEthernetPort(obj){
let result = null
      await Api().post('/aps/zhone/configureEthernetPorts', obj).then(res=>{
        result = res.data
      })
      return result
    },
    async addBridge(object) {
      let result = {
        code: 500,
        message: "No ONU ID",
      };
      if (object.onuId) {
        // Add function to create new bridge
        let obj = {
            Device_Id: object.destinationMXK,
            gponSlotId: object.destination.split('-')[1],
            gponOltId:  object.destination.split('-')[2],
            gponOnuId: object.onuId,
            gponPortId: object.gponPortId,
            vlanXlateId: object.vlanXlateId,
            slanXlateId: object.slanXlateId,
            //vlanId: object.vlanId,
            vlanId: 0,
            slanId: object.slanId,
            egressGroupIndex: object.egressGroupIndex,
            groupIndex: object.groupIndex,
            rgMode: object.rgMode,
            tpType: object.tpType,
            tpIndex: object.tpIndex,
            autoSelectGem: object.autoSelectGem,
            bridgeTemplateName: object.bridgeTemplateName
          }
          result = await this.createBridge(obj)
        
        console.log('Create Bridge', result)
      }
      // await this.delay(1000);

      return result
    },

    async addPPPOE(object) {
      let result = {
        code: 500,
        message: "No handleId",
      };
      if (object.handleId) {
          result = await this.createPPPOE(object)
        console.log('Create PPPOE', result)
      }
      // await this.delay(1000);

      return result
    },
    async addWifi(object) {
      let result = {
        code: 500,
        message: "No handleId",
      };
      if (object.handleId) {
          result = await this.createWifi(object)
        
        console.log('Create Wifi', result)
      }
      // await this.delay(1000);

      return result
    },
    async runScript() {
      this.selectItemType = "runningScript";
      this.runningScript = true
      this.timeStarted = new Date()
      this.averageTime = null
      this.etaEnd = null
      let allObjects =  [].concat.apply([], this.script.map(x=>x.objects));
      this.total = allObjects.length
      for (let i = 0; i < this.script.length; i++) {
        this.currentDevice = i + 1;
        let onuId = null;
        let handleId = null
        let ifIndex = null
        let newOnu = null

        for (let j = 0; j < this.script[i].objects.length; j++) {
          this.script[i].objects[j].started = true;

          if (this.script[i].objects[j].type == "Add ONU") {
            let addOnu = await this.addONU(this.script[i].objects[j]);
            if (addOnu && addOnu.code == 200) {
              onuId = addOnu.onuId;
              handleId = addOnu.handleId
              ifIndex = addOnu.ifIndex
              newOnu = addOnu.newONU
              this.script[i].objects[j].DeviceId = 12
              this.script[i].objects[j].ifIndex = ifIndex
              this.script[i].objects[j].onuId = onuId
              this.script[i].objects[j].success = true;
              this.script[i].objects[j].message = addOnu.message;

              this.success ++
            } else {
              this.script[i].objects[j].error = addOnu?addOnu.message:null
              this.failed ++
            }
          } else if (this.script[i].objects[j].type == "Bridge") {
            this.script[i].objects[j].onuId = onuId
            let addBridge = await this.addBridge(this.script[i].objects[j]);
            // let addBridge = await this.addBridge(this.script[i].objects[j]);
            if (addBridge && addBridge.code == 200) {
              this.script[i].objects[j].success = true;
            this.success ++
            } else {
              this.script[i].objects[j].error = addBridge?addBridge.message:null
              this.failed ++
            }
          } 
        //   else if (this.script[i].objects[j].type == "PPPOE") {
        //     this.script[i].objects[j].onuId = onuId
        //     this.script[i].objects[j].ifIndex = ifIndex
        //     this.script[i].objects[j].Device_Id = 12


        //     console.log('pppoe handle', this.script[i].objects[j])
            
        //     let pppoeHandleId = await this.fetchPPPOEDevice(this.script[i].objects[j])
        //     console.log('pppoeHandleId', pppoeHandleId)
        //     if(pppoeHandleId){
              
        // for(let i=0; i<3;i++){
        //   let obj = {
        //   DeviceId: newOnu.Device_Id,
        //   gponSlotId: newOnu.Shelf_Id, 
        //   gponPortId: newOnu.Card_Id_1, 
        //   gponOltId: newOnu.Physical_Id_1, 
        //   gponOnuId: newOnu.Physical_Id_2, 
        //   tpType: this.script[i].objects[j].tpType, 
        //   tpIndex: i+1, 
        //   vlanXlateId: this.script[i].objects[j].vlanId,
        //   vlanId: this.script[i].objects[j].vlanId
        // }
        //   let ethres = await this.attachEthernetPort(obj)
        //   console.log('ethRes', ethres)
        // }
        //       console.log('PPPOE Handle: ', pppoeHandleId)
        //       let addpppoe = await this.addPPPOE({handleId: pppoeHandleId.Handle_Id, 
        //     pppoeUsername: this.script[i].objects[j].username, 
        //     pppoePassword: this.script[i].objects[j].password});
        //      if (addpppoe && addpppoe.code == 200) {
        //       this.script[i].objects[j].success = true;
        //     this.success ++
        //     } else {
        //       this.script[i].objects[j].error = addpppoe?addpppoe.message:null
        //       this.failed ++
        //     }
        //     } else {
        //       this.script[i].objects[j].error = 'PPPOE Handle_ID not found'
        //       this.failed ++
        //     }
            
        //     // let addBridge = await this.addBridge(this.script[i].objects[j]);
           
        //   } 
          else if (this.script[i].objects[j].type == "Wifi") {
            this.script[i].objects[j].onuId = onuId
        //     for(let i=0; i<3;i++){
        //   let obj = {
        //   DeviceId: newOnu.Device_Id,
        //   gponSlotId: newOnu.Shelf_Id, 
        //   gponPortId: newOnu.Card_Id_1, 
        //   gponOltId: newOnu.Physical_Id_1, 
        //   gponOnuId: newOnu.Physical_Id_2, 
        //   tpType: 18, 
        //   tpIndex: i+1, 
        //   vlanXlateId: "",
        //   vlanId: ""
        // }
        //   let ethres = await this.attachEthernetPort(obj)
        //   console.log('ethRes', ethres)
        // }
            let addWifi = await this.addWifi({handleId: handleId, 
            ssid: this.script[i].objects[j].ssid, 
            password: this.script[i].objects[j].password});
            // let addBridge = await this.addBridge(this.script[i].objects[j]);
            if (addWifi && addWifi.code == 200) {
              this.script[i].objects[j].success = true;
            this.success ++
            } else {
              this.script[i].objects[j].error = addWifi?addWifi.message:null
              this.failed ++
            }
          }
        }
        if(i!=0){
           this.averageTime = (new Date().getTime() - this.timeStarted.getTime())/i
        }
      }
      console.log(this.script)
      let newObjects =  [].concat.apply([], this.script.map(x=>x.objects));
      this.successfulArray = newObjects.filter(x=>x.success)
      this.failedArray = newObjects.filter(x=>!x.success)

      this.runningScript = false
    },
    async buildScript(type) {
      console.log(this.sourceItem);
      console.log(this.destinationItem);
      this.loading = true;
      let script = [];
      if (type == "zhone") {
        console.log( this.devices)
        for (let i = 0; i < this.devices.length; i++) {
          let location = this.devices[i].name;
          script.push({
            type: "Add ONU",
            location: location,
            sourceMXK: this.sourceItem.Device_Id,
            destinationMXK: this.destinationItem.Device_Id,
            handleId: this.devices[i].Handle_Id,
            destination: [
              this.destinationItem.Shelf_Id,
              this.destinationItem.Card_Id_1,
              this.destinationItem.Physical_Id_1
                ? this.destinationItem.Physical_Id_1
                : location.split("-")[2],
            ].join("-"),
            fsan: this.devices[i].fullSerialNoHex,
            meProfile: this.devices[i].meProfile,
            portDesc: this.devices[i].portDesc
          });
          
        }
        for (let i = 0; i < this.dynamicOmci.length; i++) {
          let location = this.dynamicOmci[i].ssp.split(" ")[1];
          script.push({
            type: "Bridge",
            complete: false,
            started: false,
            sourceMXK: this.sourceItem.Device_Id,
            destinationMXK: this.destinationItem.Device_Id,
            location: [
              location.split(".")[0],
              location.split(".")[1],
              location.split(".")[2],
              location.split(".")[3],
            ].join("-"),
            destination: [
              this.destinationItem.Shelf_Id,
              this.destinationItem.Card_Id_1,
              this.destinationItem.Physical_Id_1
                ? this.destinationItem.Physical_Id_1
                : location.split(".")[2],
            ].join("-"),

            // Location Of Device
            Device_Id: this.dynamicOmci[i].Device_Id,
            // gponSlotId: this.dynamicOmci[i].name.split('-')[1],
            gponSlotId: this.dynamicOmci[i].name.split("-")[1],

            gponOltId: this.dynamicOmci[i].name.split("-")[2],
            gponOnuId: this.dynamicOmci[i].ssp.split(".")[3],
            gponPortId: this.dynamicOmci[i].name.split("-")[3],

            vlanXlateId: this.dynamicOmci[i].connection.vlanXlateId,
            slanXlateId: this.dynamicOmci[i].slanXlateId,
            // vlanId: this.dynamicOmci[i].vlanId,
            vlanId: 0,
            slanId: this.dynamicOmci[i].connection.slanId,

            egressGroupIndex: this.dynamicOmci[i].egressGroupIndex,
            groupIndex: this.dynamicOmci[i].groupIndex,

            rgMode: this.dynamicOmci[i].connection.rgMode,
            tpType: this.dynamicOmci[i].connection.tpType,
            tpIndex: this.dynamicOmci[i].connection.tpIndex,
            autoSelectGem: this.dynamicOmci[i].connection.autoSelectGem,
            bridgeTemplateName: this.setBridgeTemplateName(this.dynamicOmci[i].connection.vlanXlateId),
            // bridgeTemplateName: 'DownlinkSingleTagged',
            fsan: this.devices.find(
              (x) =>
                x.name ==
                [
                  location.split(".")[0],
                  location.split(".")[1],
                  location.split(".")[2],
                  location.split(".")[3],
                ].join("-")
            )
              ? this.devices.find(
                  (x) =>
                    x.name ==
                    [
                      location.split(".")[0],
                      location.split(".")[1],
                      location.split(".")[2],
                      location.split(".")[3],
                    ].join("-")
                ).fullSerialNoHex
              : null,
          });
        }

        for (let i = 0; i < this.pppoe.length; i++) {
          let location = [
            this.pppoe[i].Shelf_Id,
            this.pppoe[i].Card_Id_1,
            this.pppoe[i].Physical_Id_1,
            this.pppoe[i].Physical_Id_2,
          ].join("-");
          script.push({
            type: "PPPOE",
            complete: false,
            started: false,
            sourceMXK: this.sourceItem.Device_Id,
            destinationMXK: this.destinationItem.Device_Id,
            location: [
              this.pppoe[i].Shelf_Id,
              this.pppoe[i].Card_Id_1,
              this.pppoe[i].Physical_Id_1,
              this.pppoe[i].Physical_Id_2,
            ].join("-"),
            username: this.pppoe[i].userName,
            password: this.pppoe[i].password,
            vlanId: this.pppoe[i].vlanId,
            slanId: this.pppoe[i].slanId,
            tpType: this.pppoe[i].tpType,
            fsan: this.devices.find((x) => x.name == location)
              ? this.devices.find((x) => x.name == location).fullSerialNoHex
              : null,
          });
        }

        for (let i = 0; i < this.wifi.length; i++) {
          let location = [
            this.wifi[i].Shelf_Id,
            this.wifi[i].Card_Id_1,
            this.wifi[i].Physical_Id_1,
            this.wifi[i].Physical_Id_2,
          ].join("-");
          script.push({
            type: "Wifi",
            complete: false,
            started: false,
            sourceMXK: this.sourceItem.Device_Id,
            destinationMXK: this.destinationItem.Device_Id,
            location: location,
            ssid: this.wifi[i].ssid,
            password: this.wifi[i].encryptKey,
            fsan: this.devices.find((x) => x.name == location)
              ? this.devices.find((x) => x.name == location).fullSerialNoHex
              : null,
          });
        }
      }
      console.log(script);
      this.finalBridge = script.filter(x=>x.type=='Bridge')
      this.finalWAN = script.filter(x=>x.type=='PPPOE')
      this.finalWLAN = script.filter(x=>x.type=='Wifi')
      if(this.finalBridge.length>0){
        let keys = Object.keys(this.finalBridge[0])
        this.bridgeColumns = keys.map(x=>({
          label: x,
          field: x
        }))
      }
      
      console.log('Final bridge', this.finalBridge)

      let uniqueDevices = [...new Set(script.map((x) => x.fsan))];
      for (let i = 0; i < uniqueDevices.length; i++) {
        let objects = script.filter((x) => x.fsan == uniqueDevices[i]);
        if(uniqueDevices[i]){
           this.script.push({
          fsan: uniqueDevices[i],
          objects: objects,
          location: objects.length > 0 ? objects[0].location : null,
        });
        }
       
      }
      // console.log(this.script);
      this.loading = false;
      this.selectItemType = "script";
    },
    async collectProvisionData() {
      this.loading = true;
      let activeProvisionTypes = this.provisionTypes.filter((x) => x.value);
      if (this.sourceItem.type == "Card") {
        this.devices = await this.fetchDevicesCard(this.sourceItem);
        console.log(this.devices)
      } else if (this.sourceItem.type == "Port") {
        this.devices = await this.fetchDevicesPort(this.sourceItem);
      }
      for (let i = 0; i < activeProvisionTypes.length; i++) {
        console.log(activeProvisionTypes[i].type);
        if (activeProvisionTypes[i].type == "dynamicOmci") {
          if (this.sourceItem.type == "Card") {
            this.dynamicOmci = await this.fetchDynamicOmciProfilesCard(
              this.sourceItem
            );
            console.log('dynamicOmci', this.dynamicOmci);
          } else if (this.sourceItem.type == "Port") {
            this.dynamicOmci = await this.fetchDynamicOmciProfilesPort(
              this.sourceItem
            );
          }
        } else if (activeProvisionTypes[i].type == "pppoe") {
          if (this.sourceItem.type == "Card") {
            this.pppoe = await this.fetchPPPOEProfilesCard(this.sourceItem);
          } else if (this.sourceItem.type == "Port") {
            this.pppoe = await this.fetchPPPOEProfilesPort(this.sourceItem);
          }
        } else if (activeProvisionTypes[i].type == "wifi") {
          if (this.sourceItem.type == "Card") {
            this.wifi = await this.fetchWifiProfilesCard(this.sourceItem);
          } else if (this.sourceItem.type == "Port") {
            this.wifi = await this.fetchWifiProfilesPort(this.sourceItem);
          }
        }
      }
      this.loading = false;
      this.selectedTab = activeProvisionTypes[0].type;
      this.selectItemType = "finalVerification";
    },
    async fetchDevicesCard(item) {
      let result = [];
      await Api()
        .get(`/zhone/deviceInfo/card/${item.Device_Id}/${item.Card_Id_1}`)
        .then(async (res) => {
          console.log(res.data);
          result = await res.data.data.filter(
            (x) =>
              x.fullSerialNoHex &&
              x.fullSerialNoHex != "ZNTS0"
          );
        });

      return result;
    },
    async fetchDevicesPort(item) {
      let result = [];
      await Api()
        .get(
          `/zhone/deviceInfo/port/${item.Device_Id}/${item.Card_Id_1}/${item.Physical_Id_1}`
        )
        .then(async (res) => {
          result = await res.data.data.filter(
            (x) =>
              x.fullSerialNoHex &&
              x.fullSerialNoHex != "ZNTS0"
          );
        });
      return result;
    },
    async fetchDynamicOmciProfilesCard(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuBridges/card/${item.Device_Id}/${item.Card_Id_1}`)
        .then((res) => {
          console.log(item.Device_Id, item.Card_Id_1, res.data);
          result = res.data.data;
        });
      console.log(result.length);
      let dynamicBridges = [];
      await Api()
        .get("/zhone/dynamicbridge/" + item.Device_Id)
        .then(async (res) => {
          let output = res.data.data;
          console.log(result[0], output.map(x=>x.ifIndex));
          await output.forEach(async (x) => {
            x.connection = await result.find(
              (y) => y.bridgeIfIndex == x.ifIndex
            );
          });
          dynamicBridges = await output.filter(
            (x) => x.connection && x.name.split("-")[1] == item.Card_Id_1
          );
          // if(result){
          //   await output.forEach(async (x) => {
          //   x.connection = await result.find(
          //     (y) => y.bridgeIfIndex === x.ifIndex
          //   );
          // });
          // dynamicBridges = await output.filter(
          //   (x) =>
          //     (!result||(result && x.connection)) &&
          //     x.name.split("-")[1] == item.Card_Id_1 &&
          //     x.name.split("-")[2] == item.Physical_Id_1
          // );
          // } else{
          //   dynamicBridges = await output.filter(
          //   (x) =>
          //     x.name.split("-")[1] == item.Card_Id_1 &&
          //     x.name.split("-")[2] == item.Physical_Id_1
          // );
          // } 
        });
      return dynamicBridges;
    },
    async fetchDynamicOmciProfilesPort(item) {
      let result = [];
      await Api()
        .get(
          `/zhone/getOnuBridges/port/${item.Device_Id}/${item.Card_Id_1}/${item.Physical_Id_1}`
        )
        .then((res) => {
          result = res.data.data;
        });
      let dynamicBridges = [];
      await Api()
        .get("/zhone/dynamicbridge/" + item.Device_Id)
        .then(async (res) => {
          let output = res.data.data;
          if(result){
            await output.forEach(async (x) => {
            x.connection = await result.find(
              (y) => y.bridgeIfIndex === x.ifIndex
            );
          });
          dynamicBridges = await output.filter(
            (x) =>
              (!result||(result && x.connection)) &&
              x.name.split("-")[1] == item.Card_Id_1 &&
              x.name.split("-")[2] == item.Physical_Id_1
          );
          } else{
            dynamicBridges = await output.filter(
            (x) =>
              x.name.split("-")[1] == item.Card_Id_1 &&
              x.name.split("-")[2] == item.Physical_Id_1
          );
          } 

          console.log(output)

          
          
        });
      console.log(dynamicBridges);
      return dynamicBridges;
    },
    async fetchPPPOEProfilesCard(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuPppoe/${item.Device_Id}`)
        .then((res) => {
          result = res.data.data.filter((x) => x.Card_Id_1 === item.Card_Id_1);
        });
      return result;
    },
    async fetchPPPOEProfilesPort(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuPppoe/${item.Device_Id}`)
        .then((res) => {
          result = res.data.data.filter(
            (x) =>
              x.Card_Id_1 === item.Card_Id_1 &&
              x.Physical_Id_1 === item.Physical_Id_1
          );
        });
      return result;
    },
    async fetchPPPOEDevice(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuPppoe/${item.Device_Id}/${item.ifIndex}`)
        .then((res) => {
          // console.log('Device PPPOE Index: ', res)
          result = res.data.data.find(
            (x) =>
              x.ifIndex == item.ifIndex
          );

        });
      return result;
    },
    async fetchWifiProfilesCard(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuWlan/${item.Device_Id}`)
        .then((res) => {
          result = res.data.data.filter((x) => x.Card_Id_1 === item.Card_Id_1);
        });
      return result;
    },
    async fetchWifiProfilesPort(item) {
      let result = [];
      await Api()
        .get(`/zhone/getOnuWlan/${item.Device_Id}`)
        .then((res) => {
          result = res.data.data.filter(
            (x) =>
              x.Card_Id_1 === item.Card_Id_1 &&
              x.Physical_Id_1 === item.Physical_Id_1
          );
        });
      return result;
    },
    async buildTree(type) {
      this.itemTree = [];
      if (type == "zhone") {
        await Api()
          .get("/zhone/listAllDevices", {
            cancelToken: source.token,
          })
          .then(async (res) => {
            if (res.data && res.data.code == 200) {
              console.log(res.data);
              let result = res.data.data;
              console.log(result);
              await result.forEach((x) => {
                x.type = "MXK";
                x.children = [];
              });
              this.itemTree = result;
            }
          });
      }
    },
    async fetchLinkedData(item) {
      console.log(this.open);
      console.log(this.active)
      

      if (item.type == "MXK") {
        await this.fetchCards(item, item.Device_Id);
      } else if (item.type == "Card") {
        await this.fetchPorts(item, item.Device_Id, item.Card_Id_1);
      }
      this.open.push(item.Handle_Id)
      this.active.push(item.Handle_Id)
      // this.open.push(item.id);
    },

    async fetchCards(item, id) {
      let index = this.itemTree.indexOf(item);
      await Api()
        .get("/zhone/cards/" + id, {
          cancelToken: source.token,
        })
        .then((res) => {
          let result = res.data.data;
          result.forEach((x) => {
            x.type = "Card";
            x.children = [];
          });
          this.itemTree[index].children = result;

          this.treeUpdateKey += 1;
        });
    },

    async fetchPorts(item, deviceId, cardId) {
      await Api()
        .get("/zhone/ports/" + deviceId + "/" + cardId, {
          cancelToken: source.token,
        })
        .then((res) => {
          let result = res.data.data.filter(
            (x) => x.Handle_Type == "GponOlt_Physical"
          );
          result.forEach((x) => {
            x.type = "Port";
          });
          item.children = result;
          this.treeUpdateKey += 1;
        });
    },

    async triggerZhoneSync(){
      await Api().get('/syncLog/zhone').then(res=>{
        this.syncStarted = true
      this.syncKey ++
      }).catch(error=>{
        const msg = error && error.response && error.response.data && error.response.data.message
        alert(msg || 'The sync could not be started.')
      })
    },
    async triggerLocationSync(){
      await Api().get('/syncLog/zmsLocation').then(res=>{
        this.syncLocationStarted = true
        this.syncLocationKey ++
      }).catch(error=>{
        const msg = error && error.response && error.response.data && error.response.data.message
        alert(msg || 'The sync could not be started.')
      })
    }
  },
};
</script>